const language = {
    english: 'English',
    german: 'Deutsch',
    selectLanguage: 'Sprache Auswählen',
  } as const;

export default language;
